<template>
  <div class="home">
    <!-- Hero / Header -->
    <v-card class="hero pa-12">
      <v-row align="center">
        <!-- Columna derecha: Logo -->
        <v-col 
          cols="12" 
          md="5"
          class="text-center"
        >
          <img 
            :src="require('@/assets/logo.png')" 
            alt="Bahiol Logo" 
            class="logo"
          >
        </v-col>
        <!-- Columna izquierda: Información -->
        <v-col 
          cols="12" 
          md="7" 
          class="text-left"
        >
          <h1 class="text-h4 font-weight-bold mb-4">
            ¡Bienvenido a <span class="text-primary">Bahiol</span>!
          </h1>

          <p class="lead mb-4">
            Un espacio donde <strong>empresas, negocios, productos y servicios</strong>
          </p>

          <ul class="benefits">
            <li>✅ Encuentra los negocios y servicios que necesitas.</li>
            <li>✅ Contáctate directo con empresas y proveedores.</li>
            <li>✅ Registra tu propia empresa y muestra tus productos.</li>
            <li>✅ Llega a más gente que busca justo lo que ofreces.</li>
          </ul>

          <p class=" mt-6">
            Deja de buscar por todas partes: lo que necesitas está aquí, en <strong>Bahiol</strong>.
          </p>
          <p class="">
            <strong>¿Qué esperas? Únete hoy.</strong>
          </p>

          <!-- Llamado principal: lleva al embudo completo (cuenta, empresa,
               productos y pago). Solo para visitantes sin sesion: a quien ya
               entro no tiene sentido invitarlo a crear una cuenta. -->
          <div
            v-if="!isValid"
            class="llamado-landing mt-6"
          >
            <v-btn
              color="primary"
              size="x-large"
              class="btn-publicar"
              @click="$router.push({ name: 'LandingEmpezarView' })"
            >
              <v-icon start>mdi-storefront-outline</v-icon>
              Publica tu negocio
            </v-btn>
            <p class="texto-llamado">
              Crea tu cuenta, registra tu empresa y publica tus productos en un
              solo flujo. Desde {{ precioMesEnPesos }} COP al mes.
            </p>
          </div>

          <div 
            v-if="!isValid" 
            class="register-section mt-6"
          >
            <h3 class="text-h6 mb-3">
              ¿Quieres hacer parte de <strong>Bahiol</strong>?
            </h3>
            <p class="mb-4">
              Primero crea tu cuenta. Ya registrado puedes agregar tu empresa y publicar tus productos 🚀
            </p>
            <div class="register-actions">
              <v-btn 
                color="primary" 
                class="mr-3" 
                @click="$router.push({ name: 'RegistreView' })">
                📝 Crear cuenta
              </v-btn>
              <v-btn 
                outlined 
                color="secondary" 
                @click="$router.push({ name: 'LoginView' })">
                🔑 Iniciar sesión
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <!-- Cabeceras de seccion. Antes eran dos franjas azules con una sola
         palabra: no decian que era cada lista ni llevaban a ningun lado. -->
    <div class="cabecera-seccion">
      <div class="titulo-bloque">
        <v-icon
          size="20"
          color="primary"
        >
          mdi-store-outline
        </v-icon>
        <div>
          <h2 class="titulo-seccion">
            Empresas y negocios
          </h2>
          <p class="subtitulo-seccion">
            Los que ya están publicando en Bahiol
          </p>
        </div>
      </div>
      <v-btn
        variant="text"
        size="small"
        class="ver-todo"
        @click="$router.push({ name: 'CompanysView' })"
      >
        Ver todas
        <v-icon size="16">mdi-chevron-right</v-icon>
      </v-btn>
    </div>
    <PanelCompanies
      :page="pageCompanys"
      :length="totalPagesCompanys"
      :companies="companys"
      @onPageChange="searchCompany"
    />

    <div class="cabecera-seccion">
      <div class="titulo-bloque">
        <v-icon
          size="20"
          color="primary"
        >
          mdi-package-variant-closed
        </v-icon>
        <div>
          <h2 class="titulo-seccion">
            Productos y servicios
          </h2>
          <p class="subtitulo-seccion">
            Lo que ofrecen los negocios de la plataforma
          </p>
        </div>
      </div>
      <v-btn
        variant="text"
        size="small"
        class="ver-todo"
        @click="$router.push({ name: 'ProductsView' })"
      >
        Ver todos
        <v-icon size="16">mdi-chevron-right</v-icon>
      </v-btn>
    </div>
    <PanelProduct
      :page="page"
      :length="totalPages"
      :products="products"
      @onPageChange="searchProduct"
    />
  </div>
</template>

<script>
import apisUser from "@/apis/apisUsers"
import apisCompanys from '@/apis/apisCompanys';
import apisProducts from '@/apis/apisProducts';
import PanelProduct from '@/components/PanelProducts.vue';
import PanelCompanies from "@/components/PanelCompanies.vue";
import { precioMesHospedaje, enPesos, PRECIO_MES_RESPALDO } from '@/utils/configuracion';

export default {
  name: "HomeView",
  components: {
    PanelCompanies,
    PanelProduct
  },
  data() {
    return {
      isValid: false,
      page: 1,
      pageCompanys: 1,
      totalPages: null,
      totalPagesCompanys: null,
      companys: [],
      products: [],
      // El precio lo administra Settings. Arranca en el respaldo para que el
      // texto no parpadee ni salga vacio mientras llega la respuesta.
      precioMes: PRECIO_MES_RESPALDO,
    };
  },
  computed: {
    precioMesEnPesos() {
      return enPesos(this.precioMes);
    },
  },
  created() {
    this.search();
    precioMesHospedaje().then(precio => {
      this.precioMes = precio;
    });
    apisUser.isValid()
      .then(idValid => {
        this.isValid = idValid
        
        if (this.isValid){
          apisUser.GetMe()
            .then(user => {
                this.userInfo = user
              }
            )
        }

      }).catch(() => {

        this.isValid = false
      })

  },
  methods: {
    search() {

      this.searchCompany(1)
      this.searchProduct(this.page)
      
    },
    searchCompany(page){
      var text = ""
      
      apisCompanys.search(text,text,text, page-1)
        .then(companys =>
          {
            this.companys = companys.content
            this.totalPagesCompanys = companys.totalPages
          }
        )
    },
    searchProduct(page){
      var text = ""
      apisProducts.search(text,text,text,page - 1)
        .then(products => {  
          this.products = products.content
          this.totalPages = products.totalPages
        })
    }

  }
};
</script>

<style scoped>
/* CABECERAS DE SECCION
   Van sobre el mismo gris oscuro de los paneles que encabezan, para que se
   lean como parte de la lista y no como una franja suelta. El azul se usa
   solo en el icono y en la linea de abajo: la barra azul entera de antes
   competia con las tarjetas. */
.cabecera-seccion {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 18px 20px 12px;
  background-color: #242424;
  border-bottom: 2px solid #1976d2;
}
.titulo-bloque {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.titulo-seccion {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.2;
  color: #fff;
}
.subtitulo-seccion {
  margin: 2px 0 0;
  font-size: 0.78rem;
  color: #9aa4b2;
}
.ver-todo {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 600;
  color: #64b5f6;
}

@media screen and (max-width: 599px) {
  .cabecera-seccion {
    padding: 14px 14px 10px;
  }
  .titulo-seccion {
    font-size: 1rem;
  }
  .subtitulo-seccion {
    font-size: 0.72rem;
  }
}

/* Llamado principal a la landing.
   El hero es una foto con una capa negra al 55% y texto blanco, asi que el
   recuadro va translucido en vez de opaco: un panel claro encima de la foto
   se ve pegado con cinta. */
.llamado-landing {
  background: rgba(255, 255, 255, 0.10);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 12px;
  padding: 18px;
  backdrop-filter: blur(4px);
}
/* Boton blanco sobre foto oscura: es lo que mas resalta, y deja el azul para
   los botones secundarios de abajo */
.btn-publicar {
  width: 100%;
  font-weight: 700;
  background: #fff !important;
  color: #0d2f59 !important;
  letter-spacing: 0.02em;
}
.texto-llamado {
  font-size: 0.88rem;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.88);
  margin: 12px 0 0;
}

@media (min-width: 700px) {
  .btn-publicar {
    width: auto;
    padding-left: 32px;
    padding-right: 32px;
  }
}

.hero {
  position: relative;
  width: 100%;
  border-radius: 0;
  box-shadow: none;
  background: url('@/assets/img-vendiendo1.jpg') no-repeat center center;
  background-size: cover;
  min-height: 500px;
  color: #fff; /* texto blanco */
  z-index: 1;
}

/* capa oscura encima de la imagen */
.hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55); /* 🔹 ajusta la opacidad */
  z-index: -1; /* queda detrás del contenido */
}



.logo {
  max-width: 250px;
  width: 100%;
}
.lead {
  font-size: 1.1rem;
}
.benefits {
  list-style: none;
  padding: 0;
  margin: 0;
}
.benefits li {
  margin-bottom: 10px;
  font-size: 1rem;
}
.highlight {
  font-size: 1.05rem;
  font-style: italic;
  color: #555;
}

.register-section {

  padding: 20px;
  border-radius: 12px;
  box-shadow: 0px 4px 8px rgba(0,0,0,0.1);
  max-width: 500px;
}

.register-actions {
  color: black;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.cta {
  font-size: 1.2rem;
  color: #222;
}


.link-register {
  font-weight: bold;
  color: #1976d2;
  text-decoration: underline;
}
/**/
.slide-company{
  padding: 5px;
  background: linear-gradient(135deg, #908aff, #d1d8e4, #38d8f5);
}
.card-companies {
  display: flex;             /* ✅ mantiene todo en fila */
  flex-direction: row;
  flex-wrap:wrap;
  gap: 20px;       
  width: 100%;          /* ✅ separación entre cards */
  gap: 10px;
  justify-content: center;
  padding: 10px;
    background-color: #242424;

}

.ComponentCompany {
  /* ✅ evita que se encoja */
  margin-left: 15px;
  width: 350px;
  height: 500px;
  max-height: 1000px;
}


@media screen and (max-width: 800px) {
  .ComponentCompany{
    width: 100%;
  }
}



</style>
